// extracted by mini-css-extract-plugin
export default {"tooltip":"RP-z","arrow":"SP-z"};